export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/realistic_pattern.9f70550.svg";